import { ContextMenuMESFProvider } from "@dexteel/mesf-core";
import { CategoriesProvider } from "../categories/context/CategoriesContext";
import { ConfigurationDelayCodeProvider } from "../codes/context/ConfigurationDelayCodeContext";
import { DelaysParetoPage } from "./DelaysParetoPage";
import { DelaysParetoProvider } from "./context/DelaysParetoContext";
type Props = {
	asset: "caster" | "eaf";
};
const DelaysPareto = ({ asset }: Props) => {
	return (
		<ContextMenuMESFProvider>
			<ConfigurationDelayCodeProvider>
				<CategoriesProvider>
					<DelaysParetoProvider>
						<DelaysParetoPage asset={asset} />
					</DelaysParetoProvider>
				</CategoriesProvider>
			</ConfigurationDelayCodeProvider>
		</ContextMenuMESFProvider>
	);
};
export default DelaysPareto;
